import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../ui/Card';
import { DatePicker } from '../ui/DatePicker';
import { Badge } from '../ui/Badge';
import { ActivityProgressBadge } from './ActivityProgressBadge';
import { ActivityDetailModal } from './ActivityDetailModal';
import { operativeActivitiesStore, getProgress, OperativeActivity } from '../../services/operativeActivities';
import { actionsStore, sortActions } from '../../services/actionsStore';
import { ActionsTable } from './ActionsTable';
import { ClipboardList, Calendar, User, FileText, Briefcase, Filter } from 'lucide-react';
export function WorkloadCard() {
  const navigate = useNavigate();
  const [filterStart, setFilterStart] = useState('');
  const [filterEnd, setFilterEnd] = useState('');
  const [selectedActivity, setSelectedActivity] = useState<OperativeActivity | null>(null);
  const [isDetailOpen, setIsDetailOpen] = useState(false);
  const [refresh, setRefresh] = useState(0);
  const actions = useMemo(() => {
    let items = actionsStore.getByResponsible('Alessio');
    if (filterStart) {
      const start = new Date(filterStart);
      items = items.filter(a => new Date(a.deadline) >= start);
    }
    if (filterEnd) {
      const end = new Date(filterEnd);
      items = items.filter(a => new Date(a.deadline) <= end);
    }
    return sortActions(items);
  }, [filterStart, filterEnd, refresh]);
  const formatDate = (dateStr: string) => {
    try {
      const d = new Date(dateStr);
      return d.toLocaleDateString('it-IT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    } catch {
      return dateStr;
    }
  };
  const handleActivityClick = (activity: OperativeActivity) => {
    setSelectedActivity(activity);
    setIsDetailOpen(true);
  };
  const handleStepComplete = (activityId: string, stepIndex: number) => {
    operativeActivitiesStore.completeStep(activityId, stepIndex);
    // Refresh the selected activity reference
    const updated = operativeActivitiesStore.getById(activityId);
    if (updated) setSelectedActivity({
      ...updated
    });
    setRefresh(r => r + 1);
  };
  const handleEditActivity = (activity: OperativeActivity) => {
    setIsDetailOpen(false);
    navigate('/operations');
  };
  const handleActionUpdate = () => {
    setRefresh(r => r + 1);
  };
  return <>
      <Card title={<div className="flex items-center gap-2" data-id="element-924">
            <ClipboardList className="h-5 w-5 text-seform-orange" data-id="element-925" />
            <span data-id="element-926">Carico di lavoro (Azioni)</span>
          </div>} description="Azioni operative assegnate a te" actions={<div className="flex items-center gap-2" data-id="element-927">
            <Filter className="h-4 w-4 text-slate-400" data-id="element-928" />
            <div className="flex items-center gap-2" data-id="element-929">
              <DatePicker value={filterStart} onChange={e => setFilterStart(e.target.value)} data-id="element-930" />
              <span className="text-xs text-slate-400" data-id="element-931">—</span>
              <DatePicker value={filterEnd} onChange={e => setFilterEnd(e.target.value)} data-id="element-932" />
            </div>
          </div>} noPadding data-id="element-923">
        <div className="max-h-[420px] overflow-y-auto custom-scrollbar" data-id="element-933">
          <ActionsTable actions={actions} showClient onActionUpdate={handleActionUpdate} data-id="element-934" />
        </div>
      </Card>

      <ActivityDetailModal isOpen={isDetailOpen} onClose={() => setIsDetailOpen(false)} activity={selectedActivity} onStepComplete={handleStepComplete} onEdit={handleEditActivity} data-id="element-935" />
    </>;
}